import CheckoutForm from "./components/CheckoutForm";

function App() {
  return (
    <div>
      <CheckoutForm />
    </div>
  );
}

export default App;
